'use client';

import { setCountryOverride, type Country } from '../lib/brand';

/**
 * Pins the active country for the CLIENT module graph (escapeto only).
 *
 * Rendered by the app/[country]/ layout with the validated URL country. The
 * override is set synchronously DURING render (not in an effect) so that any
 * sibling/child client component rendered after this one — including during
 * the server-side SSR pass of client components, where `window` does not
 * exist — resolves getCountry() to the URL's country. In the browser the URL
 * path segment takes precedence anyway, so this is primarily an SSR aid.
 */
export default function CountryScope({ country }: { country: Country }) {
  setCountryOverride(country);
  return null;
}
